import * as THREE from '@phdsoft/three';
import { GaugingElement } from 'src/app/platform/busines-data/SectionElements/InspectionElements/gaugingElement';

export interface Rectd {
    decalGroup: THREE.Group;
    init: boolean;
    buttonDown: boolean;
    geom?: THREE.Geometry;
    geom1?: THREE.Geometry;
    geom2?: THREE.Geometry;
    geom3?: THREE.Geometry;
    geom4?: THREE.Geometry;
    mesh?: THREE.Mesh;
    meshs?: THREE.Mesh[];
    meshsPerTarget?: THREE.Mesh[];
    meshsAfterCut?: THREE.Mesh[][];
    inspections: GaugingElement[];
    targets?: THREE.Object3D[];
    origx: number;
    origy: number;
    inix: number;
    endx: number;
    iniy: number;
    endy: number;
    startRectangleSelection: boolean;
    isCut: boolean;
    singleGeometry: boolean;
    draw_debug_prim: boolean;
    draw_debug: boolean;
    shapeType: 'rectangle' | 'circle' | 'ellipse';
    centerX?: number;
    centerY?: number;
    radius?: number;
    radiusX?: number;
    radiusY?: number;
    cornerRadius?: number;
}

export const INITIAL_RECTD_STATE: Rectd = {
    decalGroup: new THREE.Group(),
    init: false,
    buttonDown: false,
    geom: undefined,
    geom1: undefined,
    geom2: undefined,
    geom3: undefined,
    geom4: undefined,
    mesh: undefined,
    meshs: undefined,
    meshsAfterCut: undefined,
    inspections: new Array<GaugingElement>(),
    targets: undefined,
    origx: 0,
    origy: 0,
    inix: 0,
    endx: 0,
    iniy: 0,
    endy: 0,
    startRectangleSelection: false,
    isCut: false,
    singleGeometry: true, // generate one geometry: -For all plates=true, -Per plate=false
    draw_debug_prim: false,
    draw_debug: false,
    shapeType: 'rectangle',
    centerX: undefined,
    centerY: undefined,
    radius: undefined,
    radiusX: undefined,
    radiusY: undefined,
    cornerRadius: 0.0762, // approx 3 inches
};
